import { Stack, styled } from '@mui/material'

export const Container = styled(Stack)`
  max-width: 482px;
  align-self: center;
  margin-top: 3px;
  text-align: center;
`
